// @ts-nocheck
import { toast } from "sonner";
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
// import va from "@vercel/analytics";
import { useEffect, useState } from "react";
import { Button, MenuItem, FormControl, FormControlLabel, Stack } from "@mui/material";
import DatePicker from '@components/DatePicker/DatePicker';
import TextBox from '@components/TextBox/TextBox';
import MultiSelect from '@components/CustomMultiSelect/MultiSelect';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Badge } from "@/components/ui/badge"
import { Separator } from "@/components/ui/separator"
import { Loader2, Plus, X } from "lucide-react"

import * as Sentry from "@sentry/react";
import { useModal } from "../modal/provider";
import { Checkbox, InputLabel, Select, ListItemText, Chip } from '@mui/material';
import { isEmpty, hasError, onTextPropertyChange, onPeriodChange, onUniqueTextPropertyChange } from '../../utils/validation';
import './AddForm.css';
// import MultiSelect from '@components/MultiSelect/MultiSelect';


function extractFormData(formData) {
  return _.reduce(formData, (result, v, key) => {
    if (!v.formData) {
      // TODO: handle error
      console.log(`=====extractFormData::${v.field}::`, v);
    } else {
      result[v.field] = v.formData;
      if (v.formData.default) {
        result[v.field].value = v.formData.default;
      }
    }
    
    return result;
  }, {});
}

const createMenu = async (data) => {
  console.log('createMenu::data::', data);
};

const onClose = () => {
  console.log('onClose::');
};

function AddForm({ onSave, formSchema, title, dataList, onClose }) {
  const modal = useModal();
  const [loading, setLoading] = useState(false);


  const fc = _.reduce(formSchema, (result, v, key) => {
    result[key] = v;
    let value = '';
    switch (v.type) {
      case 'date':
        value = moment(new Date()).format('YYYY-M-DD');
        break;
      case 'checkbox':
        // if v.formData.default is set, then set the value to the default
        if (typeof v.default === 'boolean') {
          value = v.default;
        }
        break;
      case 'multi-select':
        value = v.default || [];
        break;
      default:
        value = '';
    }
    result[key].value = value;
    return result;
  }, {});
  console.log('AddForm::fc::', fc);
  const [formData, setFormData] = useState(fc);

  const handleCheckboxChange = (e, field) => {
    console.log('handleCheckboxChange::', e.target.checked, field);
    setFormData({
      ...formData,
      [field]: {
        ...formData[field],
        value: !!e.target.checked,
      },
    });
  };

  const handleTextChange = (e, field) => {
    console.log('handleTextChange::', e.target.value, field);
    setFormData({
      ...formData,
      [field]: {
        ...formData[field],
        value: e.target.value,
      },
    });
  };

  const handleSelectChange = (e, field) => {
    console.log('handleSelectChange::', e.target.value, field);
    setFormData({
      ...formData,
      [field]: {
        ...formData[field],
        value: e.target.value,
      },
    });
  };

  const handleMultiSelectChange = (value, field) => {
    console.log('handleMultiSelectChange::', value, field);
    setFormData({
      ...formData,
      [field]: {
        ...formData[field],
        value: value,
      },
    });
  };

  const handleDateChange = (e, field) => {
    setFormData({
      ...formData,
      [field]: {
        ...formData[field],
        value: e.target.value,
      },
    });
  };

  const handleSave = async (e) => {
    e.preventDefault();
    const post = _.reduce(formData, (result, v, key) => {
      result[key] = v.value;
      return result;
    }, {});

    setLoading(true);
    try {
      await onSave(post);
      // `modal?.hide()` closes the legacy provider modal (ShowModalButton
      // usages); `onClose?.()` closes a controlled Dialog when the caller
      // renders AddForm inside one (e.g. the snappy MUI Dialog on the team page).
      modal?.hide();
      onClose?.();
      toast.success(`Successfully created!`);
    } catch (error) {
      const message = error?.response?.data?.error || error?.message || 'Failed to create';
      toast.error(message);
      Sentry.captureException(error);
    } finally {
      setLoading(false);
    }
  };

  const disabled = hasError(_.map(formData, 'errorMsg')) || isEmpty(_.map(_.filter(formData, { required: true }), 'value'));

  console.log('AddForm::formData::', formData);

  return (
    <div className="add-form-container">
      <Card className="add-form-card">
        <CardHeader className="add-form-header">
          <div className="add-form-title-section">
            <CardTitle className="add-form-title">
              <Plus className="add-form-title-icon" />
              {title}
            </CardTitle>
            <Badge variant="secondary" className="add-form-badge">
              New Entry
            </Badge>
          </div>
        </CardHeader>
        
        <Separator className="add-form-separator" />
        
        <CardContent className="add-form-content">
          <form onSubmit={handleSave} className="add-form-form">
            <div className="add-form-fields">
              {_.map(formData, (v, key) => {
                switch (v.type) {
                  case 'date':
                    return (
                      <div key={key} className="add-form-field">
                        <label className="add-form-label">
                          {v.label}
                          {v.required && <span className="add-form-required">*</span>}
                        </label>
                        <div className="add-form-input-wrapper">
                          <DatePicker
                            label={v.label}
                            onChange={e => handleDateChange(e, key)}
                            value={v.value}
                            className="add-form-date-picker"
                          />
                        </div>
                      </div>
                    );
                  case 'text':
                    return (
                      <div key={key} className="add-form-field">
                        <label htmlFor={v.label} className="add-form-label">
                          {v.label}
                          {v.required && <span className="add-form-required">*</span>}
                        </label>
                        <div className="add-form-input-wrapper">
                          <TextBox
                            className="add-form-text-input"
                            placeholder={v.placeholder}
                            label={v.label}
                            autoFocus={v.order === 1}
                            fullWidth
                            required={v.required}
                            formData={v}
                            onChange={e => v.unique ? onUniqueTextPropertyChange(e, key, dataList, formData, setFormData) : handleTextChange(e, key)}
                          />
                        </div>
                      </div>
                    );
                  case 'textbox':
                    return (
                      <div key={key} className="add-form-field">
                        <label htmlFor={v.label} className="add-form-label">
                          {v.label}
                          {v.required && <span className="add-form-required">*</span>}
                        </label>
                        <div className="add-form-input-wrapper">
                          <TextBox
                            className="add-form-text-input"
                            label={v.label}
                            placeholder={v.placeholder}
                            autoFocus={v.order === 1}
                            fullWidth
                            required={v.required}
                            formData={v}
                            onChange={e => v.unique ? onUniqueTextPropertyChange(e, key, dataList, formData, setFormData) : handleTextChange(e, key)}
                          />
                        </div>
                      </div>
                    );
                  case 'email':
                    return (
                      <div key={key} className="add-form-field">
                        <label htmlFor={v.label} className="add-form-label">
                          {v.label}
                          {v.required && <span className="add-form-required">*</span>}
                        </label>
                        <div className="add-form-input-wrapper">
                          <input
                            type="email"
                            id={v.label}
                            className="add-form-text-input"
                            value={v.value}
                            onChange={e => v.unique ? onUniqueTextPropertyChange(e, key, dataList, formData, setFormData) : handleTextChange(e, key)}
                            required={v.required}
                            autoFocus={v.order === 1}
                            placeholder={v.placeholder || `Enter ${_.lowerCase(v.label)}`}
                          />
                        </div>
                      </div>
                    );
                  case 'tel':
                    return (
                      <div key={key} className="add-form-field">
                        <label htmlFor={v.label} className="add-form-label">
                          {v.label}
                          {v.required && <span className="add-form-required">*</span>}
                        </label>
                        <div className="add-form-input-wrapper">
                          <input
                            type="tel"
                            id={v.label}
                            className="add-form-text-input"
                            value={v.value}
                            onChange={e => v.unique ? onUniqueTextPropertyChange(e, key, dataList, formData, setFormData) : handleTextChange(e, key)}
                            required={v.required}
                            autoFocus={v.order === 1}
                            placeholder={v.placeholder || `Enter ${_.lowerCase(v.label)}`}
                          />
                        </div>
                      </div>
                    );
                  case 'select':
                    return (
                      <div key={key} className="add-form-field">
                        <label className="add-form-label">
                          {v.label}
                          {v.required && <span className="add-form-required">*</span>}
                        </label>
                        <div className="add-form-input-wrapper">
                          <select 
                            className="add-form-select"
                            value={v.value} 
                            onChange={e => handleSelectChange(e, key)}
                            required={v.required}
                          >
                            <option value="">Select {v.label}</option>
                            {_.map(v.options, (option, key2) => {
                              return (
                                <option key={key2} value={option}>
                                  {_.capitalize(option)}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>
                    );
                  case 'multi-select':
                    return (
                      <div key={key} className="add-form-field">
                        <label className="add-form-label">
                          {v.label}
                          {v.required && <span className="add-form-required">*</span>}
                        </label>
                        <div className="add-form-input-wrapper">
                          <MultiSelect
                            label={v.label}
                            options={v.options}
                            defaultValue={v.default}
                            value={v.value}
                            onChange={value => handleMultiSelectChange(value, key)}
                            className="add-form-multi-select"
                          />
                        </div>
                      </div>
                    );
                  case 'checkbox':
                    return (
                      <div key={key} className="add-form-field add-form-checkbox-field">
                        <div className="add-form-checkbox-wrapper">
                          <Checkbox
                            key={key}
                            checked={v.value}
                            required={v.required}
                            onChange={e => handleCheckboxChange(e, key)}
                            className="add-form-checkbox"
                          />
                          <label className="add-form-checkbox-label">
                            {v.label}
                            {v.required && <span className="add-form-required">*</span>}
                          </label>
                        </div>
                      </div>
                    );
                  default:
                    return null;
                }
              })}
            </div>
            
            <div className="add-form-actions">
              <button
                type="button"
                onClick={() => { modal?.hide(); onClose?.(); }}
                className="add-form-cancel-button"
              >
                <X className="add-form-button-icon" />
                Cancel
              </button>
              <button
                type="submit"
                disabled={loading || disabled}
                className="add-form-save-button"
              >
                {loading ? (
                  <>
                    <Loader2 className="add-form-button-icon add-form-loading-icon" />
                    Creating...
                  </>
                ) : (
                  <>
                    <Plus className="add-form-button-icon" />
                    Create {title}
                  </>
                )}
              </button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}

AddForm.propTypes = {
  onSave: PropTypes.func.isRequired,
  formSchema: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  dataList: PropTypes.array,
  onClose: PropTypes.func,
};

export {
  AddForm,
  extractFormData
}

export default AddForm;
